import { SiteUrls } from '@tableau/shared-urls';

import { Messages } from '../../../codegen/Localize';
import { getSessionManagementServiceInstance } from '../../../sessionManagement/SessionManagementService';
import { ServerSettingsUnauthenticated } from '../../services/ServerSettingsUnauthenticated';
import { AuthenticationProviderType,
    DefaultAuthenticationProvider,
    IAuthenticationProvider,
    SiteAuthenticationSettingsService } from '../services/SiteAuthenticationSettingsService';

export type AuthenticationProviderSelectorProperties = {
  readonly authenticationProviderIds: string[];
  readonly authenticationProvider: IAuthenticationProvider;
  readonly authSetting: string;
  readonly getProviderDisplayName: (provider: IAuthenticationProvider) => string;
  readonly getProviderDescription: (provider: IAuthenticationProvider, inviteNotificationEnabledForSite: boolean) => string;
}

export function getDefaultAuthenticationProviderSelectorProperties(): AuthenticationProviderSelectorProperties {
  return {
    authenticationProviderIds: [],
    authenticationProvider: DefaultAuthenticationProvider,
    authSetting: 'DEFAULT',
    getProviderDisplayName: getProviderDisplayName,
    getProviderDescription: getProviderDescription
  };
}

function getProviderDisplayName(provider: IAuthenticationProvider): string {
  return SiteAuthenticationSettingsService.getProviderDisplayName(provider);
}

function getProviderDescription(provider: IAuthenticationProvider, inviteNotificationEnabledForSite: boolean): string {
  const getTranslation = (): string => {
      if (provider.type === AuthenticationProviderType.default) {
        if (ServerSettingsUnauthenticated.isTableauIdSupported()) {
          return Messages.addUsersWithAuthentication_description_tableauid();
        }
      } else {
        // Conditional descriptions for 1) both when the server config for site invite notifications is turned on and off and for 2) Site level settings on/off
        return getSessionManagementServiceInstance().isSiteInviteEmailEnabledForServer()
          ? (inviteNotificationEnabledForSite ?
            Messages.addUsersWithAuthentication_description_external_email() :
            Messages.addUsersWithAuthentication_description_external_email_off({SITE_INVITE_NOTIF_SETTINGS_URL: getSiteInviteUrl()}))
          : Messages.addUsersWithAuthentication_description_external(
            {SERVER_NAME: ServerSettingsUnauthenticated.serverName(),
            PROVIDER_NAME: SiteAuthenticationSettingsService.getProviderDisplayName(provider)});
      }
  };

  const getSiteInviteUrl = (): string => {
      const siteUrls = new SiteUrls({
        siteUrlName: getSessionManagementServiceInstance().sessionSiteUrlName(),
        queryString: window.location.search
      });
      return `<a href=${siteUrls.settingsUrl()}>${Messages.goToSiteInviteNotifSettings()}</a>`;
    };

  return getTranslation();
}
